import { StorageShapeId } from '@core/constants/Shape';
import { IFormFieldShapeQuantities } from '../../../interfaces/Form';

export const fieldsStorages: IFormFieldShapeQuantities = {
    [StorageShapeId.SimpleDrawer]: {
        value : undefined,
        min   : 0,
        max   : 5,
    },
    [StorageShapeId.SlidingShelf]: {
        value : undefined,
        min   : 0,
        max   : 5,
    },
    [StorageShapeId.StorageBox]: {
        value : undefined,
        min   : 0,
        max   : 5,
    },
};

export default fieldsStorages;
